import { render, staticRenderFns } from "./menu1_video_clip.vue?vue&type=template&id=69a81757&scoped=true"
import script from "./menu1_video_clip.vue?vue&type=script&lang=js"
export * from "./menu1_video_clip.vue?vue&type=script&lang=js"
import style0 from "./menu1_video_clip.vue?vue&type=style&index=0&id=69a81757&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a81757",
  null
  
)

export default component.exports